(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._tooltip_1u1u7_1{cursor:default;word-break:break-all;word-wrap:break-word;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}._placeholderTooltip_1u1u7_10{max-width:300px}._placeholderTagChip_1u1u7_14{display:flex;justify-content:center;transition:background .15s ease-in-out}._placeholderTagChip_1u1u7_14:hover{background:var(--dixa-color-neutral-200)}._chips_1u1u7_23{flex-wrap:nowrap}@media(min-width:768px){._chips_1u1u7_23{flex-wrap:wrap}}._hiddenTagsDropdown_1u1u7_32{max-width:100vw}")),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import ke, { useMemo as hr } from "react";
import { FlexBox as Q, DropdownButton as gr, Tooltip as Ce, Tag as Oe } from "@dixa/lib-shared-habla";
import _r from "classnames";
var B = { exports: {} }, $ = {};
var Pe;
function mr() {
  if (Pe) return $;
  Pe = 1;
  var A = ke, _ = /* @__PURE__ */ Symbol.for("react.element"), w = /* @__PURE__ */ Symbol.for("react.fragment"), R = Object.prototype.hasOwnProperty, y = A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, x = { key: !0, ref: !0, __self: !0, __source: !0 };
  function C(g, l, m) {
    var s, E = {}, O = null, N = null;
    m !== void 0 && (O = "" + m), l.key !== void 0 && (O = "" + l.key), l.ref !== void 0 && (N = l.ref);
    for (s in l) R.call(l, s) && !x.hasOwnProperty(s) && (E[s] = l[s]);
    if (g && g.defaultProps) for (s in l = g.defaultProps, l) E[s] === void 0 && (E[s] = l[s]);
    return { $$typeof: _, type: g, key: O, ref: N, props: E, _owner: y.current };
  }
  return $.Fragment = w, $.jsx = C, $.jsxs = C, $;
}
var Y = {};
var je;
function br() {
  return je || (je = 1, process.env.NODE_ENV !== "production" && (function() {
    var A = ke, _ = /* @__PURE__ */ Symbol.for("react.element"), w = /* @__PURE__ */ Symbol.for("react.portal"), R = /* @__PURE__ */ Symbol.for("react.fragment"), y = /* @__PURE__ */ Symbol.for("react.strict_mode"), x = /* @__PURE__ */ Symbol.for("react.profiler"), C = /* @__PURE__ */ Symbol.for("react.provider"), g = /* @__PURE__ */ Symbol.for("react.context"), l = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), s = /* @__PURE__ */ Symbol.for("react.suspense_list"), E = /* @__PURE__ */ Symbol.for("react.memo"), O = /* @__PURE__ */ Symbol.for("react.lazy"), N = /* @__PURE__ */ Symbol.for("react.offscreen"), ee = Symbol.iterator, De = "@@iterator";
    function Fe(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = ee && e[ee] || e[De];
      return typeof r == "function" ? r : null;
    }
    var S = A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function d(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        Ae("error", e, t);
      }
    }
    function Ae(e, r, t) {
      {
        var n = S.ReactDebugCurrentFrame, i = n.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var u = t.map(function(o) {
          return String(o);
        });
        u.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, u);
      }
    }
    var Ie = !1, We = !1, $e = !1, Ye = !1, Ne = !1, re;
    re = /* @__PURE__ */ Symbol.for("react.module.reference");
    function Me(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === R || e === x || Ne || e === y || e === m || e === s || Ye || e === N || Ie || We || $e || typeof e == "object" && e !== null && (e.$$typeof === O || e.$$typeof === E || e.$$typeof === C || e.$$typeof === g || e.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === re || e.getModuleId !== void 0));
    }
    function Ve(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function te(e) {
      return e.displayName || "Context";
    }
    function T(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && d("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case R:
          return "Fragment";
        case w:
          return "Portal";
        case x:
          return "Profiler";
        case y:
          return "StrictMode";
        case m:
          return "Suspense";
        case s:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case g:
            var r = e;
            return te(r) + ".Consumer";
          case C:
            var t = e;
            return te(t._context) + ".Provider";
          case l:
            return Ve(e, e.render, "ForwardRef");
          case E:
            var n = e.displayName || null;
            return n !== null ? n : T(e.type) || "Memo";
          case O: {
            var i = e, u = i._payload, o = i._init;
            try {
              return T(o(u));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, I = 0, ne, ae, oe, ie, ue, se, le;
    function ce() {
    }
    ce.__reactDisabledLog = !0;
    function Le() {
      {
        if (I === 0) {
          ne = console.log, ae = console.info, oe = console.warn, ie = console.error, ue = console.group, se = console.groupCollapsed, le = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        I++;
      }
    }
    function Ue() {
      {
        if (I--, I === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, e, {
              value: ne
            }),
            info: P({}, e, {
              value: ae
            }),
            warn: P({}, e, {
              value: oe
            }),
            error: P({}, e, {
              value: ie
            }),
            group: P({}, e, {
              value: ue
            }),
            groupCollapsed: P({}, e, {
              value: se
            }),
            groupEnd: P({}, e, {
              value: le
            })
          });
        }
        I < 0 && d("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = S.ReactCurrentDispatcher, q;
    function M(e, r, t) {
      {
        if (q === void 0)
          try {
            throw Error();
          } catch (i) {
            var n = i.stack.trim().match(/\n( *(at )?)/);
            q = n && n[1] || "";
          }
        return `
` + q + e;
      }
    }
    var K = !1, V;
    {
      var Be = typeof WeakMap == "function" ? WeakMap : Map;
      V = new Be();
    }
    function fe(e, r) {
      if (!e || K)
        return "";
      {
        var t = V.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      K = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var u;
      u = J.current, J.current = null, Le();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (p) {
              n = p;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (p) {
              n = p;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (p) {
            n = p;
          }
          e();
        }
      } catch (p) {
        if (p && n && typeof p.stack == "string") {
          for (var a = p.stack.split(`
`), v = n.stack.split(`
`), c = a.length - 1, f = v.length - 1; c >= 1 && f >= 0 && a[c] !== v[f]; )
            f--;
          for (; c >= 1 && f >= 0; c--, f--)
            if (a[c] !== v[f]) {
              if (c !== 1 || f !== 1)
                do
                  if (c--, f--, f < 0 || a[c] !== v[f]) {
                    var h = `
` + a[c].replace(" at new ", " at ");
                    return e.displayName && h.includes("<anonymous>") && (h = h.replace("<anonymous>", e.displayName)), typeof e == "function" && V.set(e, h), h;
                  }
                while (c >= 1 && f >= 0);
              break;
            }
        }
      } finally {
        K = !1, J.current = u, Ue(), Error.prepareStackTrace = i;
      }
      var D = e ? e.displayName || e.name : "", j = D ? M(D) : "";
      return typeof e == "function" && V.set(e, j), j;
    }
    function Je(e, r, t) {
      return fe(e, !1);
    }
    function qe(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function L(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return fe(e, qe(e));
      if (typeof e == "string")
        return M(e);
      switch (e) {
        case m:
          return M("Suspense");
        case s:
          return M("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case l:
            return Je(e.render);
          case E:
            return L(e.type, r, t);
          case O: {
            var n = e, i = n._payload, u = n._init;
            try {
              return L(u(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var W = Object.prototype.hasOwnProperty, de = {}, ve = S.ReactDebugCurrentFrame;
    function U(e) {
      if (e) {
        var r = e._owner, t = L(e.type, e._source, r ? r.type : null);
        ve.setExtraStackFrame(t);
      } else
        ve.setExtraStackFrame(null);
    }
    function Ke(e, r, t, n, i) {
      {
        var u = Function.call.bind(W);
        for (var o in e)
          if (u(e, o)) {
            var a = void 0;
            try {
              if (typeof e[o] != "function") {
                var v = Error((n || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw v.name = "Invariant Violation", v;
              }
              a = e[o](r, o, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (c) {
              a = c;
            }
            a && !(a instanceof Error) && (U(i), d("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, o, typeof a), U(null)), a instanceof Error && !(a.message in de) && (de[a.message] = !0, U(i), d("Failed %s type: %s", t, a.message), U(null));
          }
      }
    }
    var Ge = Array.isArray;
    function G(e) {
      return Ge(e);
    }
    function ze(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Xe(e) {
      try {
        return pe(e), !1;
      } catch {
        return !0;
      }
    }
    function pe(e) {
      return "" + e;
    }
    function he(e) {
      if (Xe(e))
        return d("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ze(e)), pe(e);
    }
    var ge = S.ReactCurrentOwner, He = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, me;
    function Ze(e) {
      if (W.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Qe(e) {
      if (W.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function er(e, r) {
      typeof e.ref == "string" && ge.current;
    }
    function rr(e, r) {
      {
        var t = function() {
          _e || (_e = !0, d("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function tr(e, r) {
      {
        var t = function() {
          me || (me = !0, d("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var nr = function(e, r, t, n, i, u, o) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: _,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: u
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(a, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(a, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function ar(e, r, t, n, i) {
      {
        var u, o = {}, a = null, v = null;
        t !== void 0 && (he(t), a = "" + t), Qe(r) && (he(r.key), a = "" + r.key), Ze(r) && (v = r.ref, er(r, i));
        for (u in r)
          W.call(r, u) && !He.hasOwnProperty(u) && (o[u] = r[u]);
        if (e && e.defaultProps) {
          var c = e.defaultProps;
          for (u in c)
            o[u] === void 0 && (o[u] = c[u]);
        }
        if (a || v) {
          var f = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && rr(o, f), v && tr(o, f);
        }
        return nr(e, a, v, i, n, ge.current, o);
      }
    }
    var z = S.ReactCurrentOwner, be = S.ReactDebugCurrentFrame;
    function k(e) {
      if (e) {
        var r = e._owner, t = L(e.type, e._source, r ? r.type : null);
        be.setExtraStackFrame(t);
      } else
        be.setExtraStackFrame(null);
    }
    var X;
    X = !1;
    function H(e) {
      return typeof e == "object" && e !== null && e.$$typeof === _;
    }
    function ye() {
      {
        if (z.current) {
          var e = T(z.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function or(e) {
      return "";
    }
    var Ee = {};
    function ir(e) {
      {
        var r = ye();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Re(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ir(r);
        if (Ee[t])
          return;
        Ee[t] = !0;
        var n = "";
        e && e._owner && e._owner !== z.current && (n = " It was passed a child from " + T(e._owner.type) + "."), k(e), d('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), k(null);
      }
    }
    function Te(e, r) {
      {
        if (typeof e != "object")
          return;
        if (G(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            H(n) && Re(n, r);
          }
        else if (H(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = Fe(e);
          if (typeof i == "function" && i !== e.entries)
            for (var u = i.call(e), o; !(o = u.next()).done; )
              H(o.value) && Re(o.value, r);
        }
      }
    }
    function ur(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === E))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = T(r);
          Ke(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !X) {
          X = !0;
          var i = T(r);
          d("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && d("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function sr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            k(e), d("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), k(null);
            break;
          }
        }
        e.ref !== null && (k(e), d("Invalid attribute `ref` supplied to `React.Fragment`."), k(null));
      }
    }
    var we = {};
    function xe(e, r, t, n, i, u) {
      {
        var o = Me(e);
        if (!o) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var v = or();
          v ? a += v : a += ye();
          var c;
          e === null ? c = "null" : G(e) ? c = "array" : e !== void 0 && e.$$typeof === _ ? (c = "<" + (T(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : c = typeof e, d("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", c, a);
        }
        var f = ar(e, r, t, i, u);
        if (f == null)
          return f;
        if (o) {
          var h = r.children;
          if (h !== void 0)
            if (n)
              if (G(h)) {
                for (var D = 0; D < h.length; D++)
                  Te(h[D], e);
                Object.freeze && Object.freeze(h);
              } else
                d("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Te(h, e);
        }
        if (W.call(r, "key")) {
          var j = T(e), p = Object.keys(r).filter(function(pr) {
            return pr !== "key";
          }), Z = p.length > 0 ? "{key: someKey, " + p.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!we[j + Z]) {
            var vr = p.length > 0 ? "{" + p.join(": ..., ") + ": ...}" : "{}";
            d(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Z, j, vr, j), we[j + Z] = !0;
          }
        }
        return e === R ? sr(f) : ur(f), f;
      }
    }
    function lr(e, r, t) {
      return xe(e, r, t, !0);
    }
    function cr(e, r, t) {
      return xe(e, r, t, !1);
    }
    var fr = cr, dr = lr;
    Y.Fragment = R, Y.jsx = fr, Y.jsxs = dr;
  })()), Y;
}
var Se;
function yr() {
  return Se || (Se = 1, process.env.NODE_ENV === "production" ? B.exports = mr() : B.exports = br()), B.exports;
}
var b = yr();
const Er = "_tooltip_1u1u7_1", Rr = "_placeholderTooltip_1u1u7_10", Tr = "_placeholderTagChip_1u1u7_14", wr = "_chips_1u1u7_23", xr = "_hiddenTagsDropdown_1u1u7_32", F = {
  tooltip: Er,
  placeholderTooltip: Rr,
  placeholderTagChip: Tr,
  chips: wr,
  hiddenTagsDropdown: xr
}, jr = ({
  className: A,
  tags: _,
  limit: w = _.length,
  tagClassName: R,
  onRemove: y,
  getHiddenTagsLabel: x = (g) => `+${g}`,
  ...C
}) => {
  const { visibleTags: g, hiddenTags: l } = hr(
    () => ({
      visibleTags: _.slice(0, w),
      hiddenTags: _.slice(w)
    }),
    [_, w]
  ), m = (s) => /* @__PURE__ */ b.jsx(
    Ce,
    {
      wrapProps: { className: F.tooltip },
      content: s.name,
      children: /* @__PURE__ */ b.jsx(
        Oe,
        {
          className: R,
          color: s.color,
          disabled: s.is_deactivated,
          onDelete: y && (() => y(s)),
          children: s.name
        }
      )
    },
    s.id
  );
  return /* @__PURE__ */ b.jsxs(
    Q,
    {
      gap: "200",
      alignItems: "center",
      className: _r(F.chips, A),
      ...C,
      children: [
        g.map((s) => m(s)),
        l.length > 0 && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          y && /* @__PURE__ */ b.jsx(
            gr,
            {
              buttonProps: {
                variant: "tertiary",
                className: F.hiddenTagsDropdown
              },
              fixed: !0,
              dropdown: /* @__PURE__ */ b.jsx(
                Q,
                {
                  flexWrap: "wrap",
                  gap: "100",
                  padding: "200 300",
                  width: "100%",
                  maxWidth: "300px",
                  children: l.map((s) => m(s))
                }
              ),
              children: x(l.length)
            }
          ),
          !y && /* @__PURE__ */ b.jsx(
            Ce,
            {
              className: F.placeholderTooltip,
              wrapProps: { className: F.tooltip },
              content: /* @__PURE__ */ b.jsx(Q, { flexWrap: "wrap", gap: "100", children: l.map((s) => m(s)) }),
              light: !0,
              children: /* @__PURE__ */ b.jsx(Oe, { noTruncation: !0, className: F.placeholderTagChip, children: x(l.length) })
            }
          )
        ] })
      ]
    }
  );
};
export {
  jr as TagChips
};
//# sourceMappingURL=index.js.map
